import request from '@/utils/request'

export function giftBagList (params) {
  return request({
    method: 'get',
    params: {
      r: 'gift/bag-list',
      ...params
    }
  })
}

export function getGiftBag (params) {
  return request({
    method: 'get',
    params: {
      r: 'gift/receive',
      ...params
    }
  })
}
